var $c427e4a9ab6700b2$exports = {};
$c427e4a9ab6700b2$exports = {
    "help": `N\xe1pov\u{11B}da`,
    "info": `Informace`
};


export {$c427e4a9ab6700b2$exports as default};
//# sourceMappingURL=cs-CZ.module.js.map
